import { render, staticRenderFns } from "./CreatePlatform.vue?vue&type=template&id=2e8f2d0f&scoped=true"
import script from "./CreatePlatform.vue?vue&type=script&lang=js"
export * from "./CreatePlatform.vue?vue&type=script&lang=js"
import style0 from "./CreatePlatform.vue?vue&type=style&index=0&id=2e8f2d0f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8f2d0f",
  null
  
)

export default component.exports